<template>
  <section class="page-header-card ps-md-5 pe-2 mx-md-4 pt-3 pt-md-0 ps-3 ps-md-0 mt-md-3">
    <div class="ph-wrap">
      <div class="ph-left">
        <div>
          <div v-if="overline" class="ph-overline">{{ overline }}</div>
          <h2 class="ph-title">{{ title }}</h2>
        </div>
      </div>

      <div class="ph-right">
        <div class="ph-subtitle-wrap d-none d-md-block" v-if="subtitle">
          <p class="ph-subtitle ph-subtitle-right">{{ subtitle }}</p>
        </div>
        <img
          src="../assets/img/header_img.png"
          alt="header-right"
          class="ph-right-img"
        />
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    overline: { type: String, default: "" },
    icon: { type: String, default: "" }
  }
};
</script>

<style scoped>
.page-header-card {
  background: #ecf2ff;
  border-radius: 8px;
  --ph-pad-y: 1.5rem;
}

.ph-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.ph-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 56px;
}

.ph-overline {
  font-size: 13px;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #8392ab;
  margin-bottom: 2px;
  font-weight: 700;
}

.ph-title {
  margin: 0;
  font-weight: 700;
  font-size: 24px;
  color: #344767;
  line-height: 1.3;
}

.ph-subtitle {
  margin: 8px 0 0;
  font-size: 14px;
  color: #6c7a91;
}

.ph-right {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-end;   /* 세로 하단 맞춤 */
  gap: 8px;                /* 글자와 이미지 간격 */
}

.ph-subtitle-right {
  font-size: 14px;
  color: #6c7a91;
  margin: 0;
  text-align: right;       /* 오른쪽 정렬 */
}

/* 이미지: 크기만 키우고, 위쪽 잘리게 */
.ph-right-img {
  width: 180px;              /* 원하는 폭 */
  height: 120px;             /* 원하는 높이 */
  object-fit: cover;         /* 이미지 위/옆 잘라내고 꽉 채움 */
  object-position: top;      /* 위쪽 맞춤 (상단 자르고 아래 붙임) */
  border-radius: 6px;
}

.ph-left > div,
.ph-subtitle-wrap {
  transform: translateY(-10px);  /* 원하는 만큼 위로 */
}

/* 반응형 */
@media (max-width: 768px) {
  .ph-wrap {
    flex-direction: column;
    align-items: flex-start;
  }
  .ph-right {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }
}
</style>
